var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.67 59.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00abee",
    d: "M99,27.11a3.58,3.58,0,0,0,1.17,2.38c1.68,1.67,4.25,1.77,7.93,1.79,2.8-.15,5.3-1.3,6-2.13a2.17,2.17,0,0,0-.19-2.95,11.48,11.48,0,0,0-4.39-1.94c-2.1-.42-11.91-2.23-14.65-3a15.67,15.67,0,0,1-5.4-2.7A6,6,0,0,1,87.22,15a6.42,6.42,0,0,1,1.62-5.73C90.53,7.43,93,5.85,97.24,5A43.57,43.57,0,0,1,112,4.48a26.82,26.82,0,0,1,7.16,1.82,13.18,13.18,0,0,1,4.11,2.59c1.21,1.17,2.46,3.9,2.31,4.87H113.3a2.85,2.85,0,0,0-1-1.91c-1.3-1.26-3.83-1.67-4.87-1.76-4-.39-6.72.31-7.82,1.48a2.44,2.44,0,0,0-.76,2.16c.28,1.31,2.46,2.4,4.62,2.86s12,2.33,14.86,3.15a16,16,0,0,1,5.3,2.6,6,6,0,0,1,2.43,3.75,6.26,6.26,0,0,1-1.14,5,15.82,15.82,0,0,1-7.32,4.62C113.18,37.1,106.7,37.2,104,37a34.94,34.94,0,0,1-9.55-1.77,13.91,13.91,0,0,1-5.91-3.66A6.06,6.06,0,0,1,87,27.14Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00abee",
    x: 44.71,
    y: 5.86,
    width: 35.01,
    height: 6.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00abee",
    x: 44.71,
    y: 18.52,
    width: 35.01,
    height: 6.73
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00abee",
    x: 44.71,
    y: 31.18,
    width: 35.01,
    height: 6.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00abee",
    d: "M11.29,24.65V37H0V4.6H20.21a41.85,41.85,0,0,1,7.58.63C33.36,6.14,36.33,8,38.44,11a6.88,6.88,0,0,1,0,7.16,9.89,9.89,0,0,1-3.59,3.42,31.38,31.38,0,0,1-10.39,2.89C22.78,24.63,11.48,24.65,11.29,24.65Zm0-5.74h8.42c1.23,0,6.63,0,8-3.48a3.41,3.41,0,0,0-1.5-3.74c-2.18-1.49-5-1.37-6.09-1.37H11.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00abee",
    d: "M145.63,8.91h-.75V3.26h2.19c1.83,0,2.16.61,2.24,1.25a1.48,1.48,0,0,1-.26,1.19,1.44,1.44,0,0,1-.73.5,2.5,2.5,0,0,0-.54.13h0a2.37,2.37,0,0,1,.9.85c.35.52,1,1.65,1,1.68h-.88a.06.06,0,0,1-.08,0l-1-1.6a5.21,5.21,0,0,0-.41-.52,1,1,0,0,0-.74-.33h-1.06Zm0-3.15h2.22a.9.9,0,0,0,.76-.84.84.84,0,0,0-.55-.87,1.69,1.69,0,0,0-.59-.09h-1.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00abee",
    d: "M146.91,0A5.71,5.71,0,1,0,147,0ZM147,10.59a5,5,0,1,1,5-5A5,5,0,0,1,147,10.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M.55,43.17s57,18.36,107.73,4.46c8-1.93,35.16-14.59,30.77-29,10.76,3.77,13.43,14.69,5.64,22.51-6.07,6.1-13.93,9-21.92,11.43C112.71,55.64,46.49,71.53.55,43.17Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.98a83a7d8dbfdd938ddc29bc040e1a42.svg";
export { ForwardRef as ReactComponent };